import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/udi-logo.png'


const _hoisted_1 = { class: "contenedor-menu" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "medio" }
const _hoisted_4 = { class: "contenedor" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  alt: "imagen centrada",
  class: "imagen-centrada"
}

import AppMenu from '../components/AppMenu.vue';
import BarraSuperior from '../components/BarraSuperior.vue';
import { useRoute } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'PaginaPrincipal',
  setup(__props) {

/**
 * Layout raíz de la aplicación: menú lateral, barra superior y `router-view`.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/Gestion` (Inicio) — sin permiso específico
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const route = useRoute()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppMenu),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BarraSuperior),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("main", _hoisted_4, [
          (_unref(route).path === '/Gestion')
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
        ])
      ])
    ])
  ]))
}
}

})